import ObjectUtils from '@spothero/utils/object';
import {spotheroPatch} from 'api';
import {sendSentryException} from 'utils/error-handling';

/**
 * Format the response from the update exception API call.
 * @function formatUpdateExceptionResponse
 * @param response
 * @return {*}
 *
 * @memberof module:api/inventory/dto
 */
const formatUpdateExceptionResponse = (response) => {
    const formattedResponse = ObjectUtils.camelizeKeys(response);

    return formattedResponse;
};

/**
 * Update an inventory rule exception for a given facility.  Used when editing a single property of an inventory rule (e.g. status).
 * @param {number} facilityId - The facility id.
 * @param {number} ruleId - The rule id.
 * @param {TInventoryRule} values - The inventory rule properties to update.
 * @return {Promise<TInventoryRule>}
 *
 * @see '/api/v1/facilities/{facilityId}/inventory-rules/{ruleId}/'
 *
 */
const updateException = async (facilityId, ruleId, values) => {
    try {
        const {data} = await spotheroPatch(
            `facilities/${facilityId}/inventory-rules/${ruleId}/`,
            values
        );

        const formattedResponse = formatUpdateExceptionResponse(data.data);

        return formattedResponse;
    } catch (error) {
        sendSentryException(error);

        throw error;
    }
};

export default updateException;
